import React, { useRef } from 'react';

interface IConfigListEditorProps {
  title: string;
  items: string[];
  newItem: string;
  onNewItemChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onAddItem: () => void;
  onDeleteItem: (index: number) => void;
  placeholder: string;
  subHeader?: string;
  showDeleteForOriginalItem?: boolean;
  disabled?: boolean;
}

const StringListEditor: React.FC<IConfigListEditorProps> = ({
  title,
  items,
  newItem,
  onNewItemChange,
  onAddItem,
  onDeleteItem,
  placeholder,
  showDeleteForOriginalItem = false,
  subHeader,
  disabled = false,
}) => {
  const originalItemsRef = useRef<string[]>(items);

  return (
    <div style={styles.formColumn}>
      <h3 style={styles.columnHeader} className='leaderboard-create-headers'>
        {title}
      </h3>
      {!!subHeader && (
        <h4>{subHeader}</h4>
      )}
      {items.map((item, index) => (
        <div key={index} style={styles.teamRow}>
          <span>{item}</span>
          {(showDeleteForOriginalItem || !originalItemsRef.current.includes(item)) && (
            <button
              type='button'
              onClick={() => onDeleteItem(index)}
              style={styles.deleteButton}
              className='leaderboard-create-headers'
              disabled={disabled}
            >
              X
            </button>
          )}
        </div>
      ))}
      <input
        type='text'
        value={newItem}
        onChange={onNewItemChange}
        placeholder={placeholder}
        style={styles.inputField}
        disabled={disabled}
      />
      <button type='button' onClick={onAddItem} className='jr-btn-default' disabled={disabled}>
        Add
      </button>
    </div>
  );
};

const styles: { [key: string]: React.CSSProperties } = {
  formColumn: {
    marginRight: '16px',
  },
  columnHeader: {
    marginBottom: '8px',
    display: 'flex',
    alignItems: 'center',
    fontWeight: 'bold',
    fontSize: '1.2rem',
  },
  teamRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '8px',
  },
  deleteButton: {
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    fontSize: '1rem',
  },
  inputField: {
    width: '100%',
    padding: '8px',
    marginBottom: '8px',
    border: '1px solid #ccc',
    borderRadius: '4px',
  },
};

export default StringListEditor;
